import { z } from 'zod'

export const passwordResetFormSchema = z.object({
  email: z.string().min(1).email(),
})
